import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { accountRoute } from '../../../routes';

import ReactDOM from 'react-dom';
import SweetScroll from 'sweet-scroll';

import ContentBlock from '../block/content';

export default class AccountCaseCreateStepGeneric extends Component {
	static propTypes = {
		active: PropTypes.bool.isRequired,
		stepTitle: PropTypes.string,
		stepNumber: PropTypes.string,
		summary: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.object,
		]),
		editLink: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.object,
		]),
	};

	static defaultProps = {
		active: false,
		stepTitle: '',
		stepNumber: '00',
		summary: false,
		editLink: false,
	};

	constructor(props) {
		super();

		this.state = {
			hasBeenActive: false,
		};
	};

	componentWillMount() {}

	componentWillReceiveProps(nextProps) {
		if (nextProps.active) {
			this.setState({
				...this.state,
				hasBeenActive: true,
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevProps.active && this.props.active) {
			let element = ReactDOM.findDOMNode(this.refs.step);
			if (element && typeof element.getAttribute === 'function') {
				setTimeout(() => {
					const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 1000 });
					scroller.toElement(element);
				}, 500);

			}
		}
	}

	render() {
		let stepHeadClass = 'account-process__step-head';
		let stepClass = 'account-process__step';

		if (this.props.active) {
			stepClass += ' account-process__step--active';

		}

		if (this.props.active || this.state.hasBeenActive) {
			stepHeadClass += ' account-process__step-head--active';
		}

		return (
			<div ref='step'>
				<div className={stepHeadClass}>
					<div className='span2 span4-mobile pixel-pattern-overlay pixel-pattern-overlay--01 account-process__step-head__counter'>
						{this.props.stepNumber}
					</div>
					<div className='span12 span10-mobile account-process__step-head__content'>

						<ContentBlock title={this.props.stepTitle} smallAside={true}>
							{this.props.summary}
						</ContentBlock>

					</div>
					<div className='cf'></div>
				</div>

				<div className={stepClass}>
					<div className='span2 hide-mobile'><br/></div>
					<div className='span12 span14-mobile account-process__step__content'>
						{this.props.children}
					</div>
					<div className='cf'></div>
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jobCreate/stepGeneric.js
 **/